import { CARD_BORDER_RADIUS, CARD_BOX_SHADOW } from 'developer-docs-shared-components/config/cssConstants';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCard = styled.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-1rnrimh-0"
})(["background-color:", ";border-radius:", "px;box-shadow:", ";margin-block:", ";padding:", ";"], ({
  theme
}) => theme.color['fill-surface-default'], CARD_BORDER_RADIUS, CARD_BOX_SHADOW, ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.space[600]);

/**
 * The new card variant. Eventually all cards will be migrated to the new
 * card component, so use this for UX consistency.
 *
 * TODO: From sync with Brett on Sept 22, add docs explaining why there are
 * two (ContentCard and Card). Apply grey BG when on in-app theme. Make
 * multiple card variant for eventual migration from extracted card to new
 * designed card.
 */
const Card = ({
  children
}) => {
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(StyledCard, {
    children: children
  });
};
export default Card;